export default class DigitalData {
  /**
   * Добавляет ключ events в объект digitalData
   */
  static addEvent() {
    if (window.digitalData !== undefined) {
      if (!Object.prototype.hasOwnProperty.call(window.digitalData, 'events')) {
        window.digitalData.events = window.digitalData.events || [];
      }
    }
  }

  /**
   * Добавляет ключ changes в объект digitalData
   */
  static addrChanges() {
    if (window.digitalData !== undefined) {
      if (!Object.prototype.hasOwnProperty.call(window.digitalData, 'changes')) {
        window.digitalData.changes = window.digitalData.changes || [];
      }
    }
  }

  /**
   * Отправляет событие в объект digitalData
   * @param event - объект события
   * @param type - тип события
   */
  static pushEvent(event, type = 'events') {
    const eventPush = event || {};

    switch (type) {
      case 'events': {
        this.addEvent();

        if (window.digitalData !== undefined) {
          window.digitalData.events.push(eventPush);
        }
        break;
      }
      case 'changes': {
        this.addrChanges();

        if (window.digitalData !== undefined) {
          window.digitalData.changes.push(eventPush);
        }
        break;
      }
    }
  }
}
